/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../../ColorsProvider";
import Tappable, { simpleActiveBackgroundColor } from "../../Tappable";
import NoStyleButton from "../../NoStyleButton";

type Props = {
  colors: ColorSet,
  kind: "heat" | "cool",
  label?: ?string,
  onTap?: ?() => void,
  value?: ?number,
};

class ValueCallout extends React.Component<Props> {
  render() {
    const { colors, kind, label, onTap, value } = this.props;
    const kindStyles = {
      heat: {
        color: colors.HEAT,
      },
      cool: {
        color: colors.COOL,
      },
    };

    const styles = {
      container: {
        display: "inline-block",
        textAlign: "center",
        cursor: "pointer",
        outline: "none",
        borderRadius: "4px",
        ...kindStyles[kind],
      },
      value: {
        fontSize: 24,
        textAlign: "center",
        verticalAlign: "middle",
      },
      label: {
        fontSize: 14,
        whiteSpace: "nowrap",
        textAlign: "center",
        textTransform: "uppercase",
      },
    };

    return (
      <Tappable onTap={onTap}>
        {({ active, tapTargetRefHandler }) => (
          <NoStyleButton
            style={{
              ...styles.container,
              backgroundColor: simpleActiveBackgroundColor(active),
            }}
            innerRef={tapTargetRefHandler}
          >
            <span style={styles.value}>
              {value}
              {"°"}
            </span>
            <div style={styles.label}>{label}</div>
          </NoStyleButton>
        )}
      </Tappable>
    );
  }
}

export default withColorsProvider(ValueCallout);



// WEBPACK FOOTER //
// ../nx-components/src/Thermostat/TileControls/ValueCallout.jsx